import { Div2Floor } from "./Div2Floor";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Param4 } from "./XML_Param4";
import { RoundTo3 } from "./RoundTo3";
import { XML_Scale } from "./XML_Scale";

export function XML_DrawTri2PPT(
  sx,
  sy,
  width,
  height,
  triColor,
  subTriColor,
  drawElement,
  layer,
  borderThickness,
  dashStyle,
  borderColor,
  leftTri
) {
  var ex = sx + width;
  var ey = sy + height;

  var inset = 2;
  var h = ey - sy - inset * 2;
  var ax = ex - inset - h;
  var ay = sy + inset;
  var cx = ex - inset;
  var cy = ey - inset;

  ax = XML_ScaleAndShiftX(ax, drawElement, layer);
  cx = XML_ScaleAndShiftX(cx, drawElement, layer);
  ay = XML_ScaleAndShiftY(ay, drawElement, layer);
  cy = XML_ScaleAndShiftY(cy, drawElement, layer);

  if (leftTri)
    XML_Cmd4("ltri", RoundTo3(ax), RoundTo3(ay), RoundTo3(cx - ax), RoundTo3(cy - ay), drawElement);
  else
    XML_Cmd4("rtri", RoundTo3(ax), RoundTo3(ay), RoundTo3(cx - ax), RoundTo3(cy - ay), drawElement);
  XML_Param4("p", triColor, borderColor, borderThickness, dashStyle, drawElement);

  if (subTriColor != null) {
    var h2 = Div2Floor(h) - 1;
    h2 = XML_Scale(h2, drawElement, layer);
    ay = ay + h2;
    ax = ax + h2;
    if (leftTri)
      XML_Cmd4(
        "ltri",
        RoundTo3(ax - h2),
        RoundTo3(ay),
        RoundTo3(cx - ax),
        RoundTo3(cy - ay),
        drawElement
      );
    else
      XML_Cmd4(
        "rtri",
        RoundTo3(ax),
        RoundTo3(ay),
        RoundTo3(cx - ax),
        RoundTo3(cy - ay),
        drawElement
      );
    XML_Param4("p", subTriColor, borderColor, borderThickness, dashStyle, drawElement);
  }
}
